import * as yup from "yup";

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Grid } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import messages from "../../../../utils/messages";
import serviceFaturaPrevista from "../../../../services/serviceFaturaPrevista";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { Loader } from "./styles";

export interface IDialogProps {
    open: boolean;
    onClose?: any;
    onCancel?: any;
    idProp?: any;
}

const schema = yup.object().shape({
    motivo: yup.string().required(messages.requiredField),
});

export default function DialogReopen({ open, onClose, onCancel, idProp }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);

    const {
        reset,
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        resolver: yupResolver(schema),
    });

    const handleRequest = () => {        
        setDisable(true);
      
        serviceFaturaPrevista
            .reopen(idProp.id)
            .then((result) => {
                if (result) {
                    toast.success("Fatura reaberta com sucesso!");
                    reset();
                    onClose(true);
                }
            })
            .finally(() => {
                setDisable(false);
            });
    };

    const onCancelReopen = () => {
        reset();
        onCancel(true);
    };

    return (
        <>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onCancel();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    Reabrir Fatura                  
                    <IconButton
                        aria-label="close"
                        onClick={onCancel}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                
                <DialogContent dividers>
                    <Grid item xs={12}>
                        {isDisable && (
                            <Loader>
                                <img alt="Loading" src="/Loading.gif" width="40px" height="40px" />
                            </Loader>
                        )}
                    </Grid>
                    <Box>
                        <Grid>
                            <Typography variant="subtitle2">Fatura Prevista ID: {idProp?.id}</Typography>
                            <Typography variant="subtitle2">Num. Instalação: {idProp?.numeroInstalacao}</Typography>
                            <Typography variant="subtitle2">Ciclo: {idProp?.cicloFaturamento}</Typography>
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button 
                        onClick={() => onCancelReopen()} 
                        color="warning" 
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>

                    <Button
                        onClick={() => handleRequest()}
                        color="primary"
                        variant="contained"
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
